import { useEffect } from 'react';

const Form = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    // Load the GoHighLevel form embed script
    const script = document.createElement('script');
    script.src = 'https://link.msgsndr.com/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);

    // Cleanup script on unmount
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 to-cyan-50 py-12 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white/90 backdrop-blur-sm rounded-3xl border border-teal-200/50 p-8 shadow-xl">
          <div className="w-full">
            <iframe
              src="https://api.leadconnectorhq.com/widget/form/E3YxL37tNq7wk1vAYDDf"
              style={{
                width: '100%',
                height: '805px',
                border: 'none',
                borderRadius: '4px'
              }}
              id="inline-E3YxL37tNq7wk1vAYDDf"
              data-layout="{'id':'INLINE'}"
              data-trigger-type="alwaysShow"
              data-trigger-value=""
              data-activation-type="alwaysActivated"
              data-activation-value=""
              data-deactivation-type="neverDeactivate"
              data-deactivation-value=""
              data-form-name="Form 0"
              data-height="805"
              data-layout-iframe-id="inline-E3YxL37tNq7wk1vAYDDf"
              data-form-id="E3YxL37tNq7wk1vAYDDf"
              title="Form 0"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
